/**
 * Where the Veivo SDK's desktop -> phone QR sends the phone: the PUBLIC
 * verification page, never the authed route the flow is mounted on (the SDK's
 * default would deep-link back there and hit the login wall).
 *
 * A handoff code identifies the validation by itself, so the URL needs nothing
 * else — which keeps the QR coarse enough to scan off a screen and the session
 * token out of the phone's address bar. Without a code it falls back to the
 * validation id + token: a denser QR, but a working link beats a dead end.
 */
export const veivoHandoffUrl = ({
  validationId,
  handoffCode,
  sessionToken,
}: {
  validationId: string;
  handoffCode: string | null;
  sessionToken: string | null;
}): string => {
  const base = (import.meta.env.VITE_RIDEMINDER_BASE_NAME || "").replace(/^\/|\/$/g, "");
  const url = new URL(`${base ? `/${base}` : ""}/veivo-verification`, window.location.origin);

  if (handoffCode) {
    url.hash = `h=${handoffCode}`;
  } else {
    url.searchParams.set("veivoValidationId", validationId);
    if (sessionToken) url.hash = `veivoSessionToken=${sessionToken}`;
  }
  return url.toString();
};
